import {
  RegistrationRequestInput,
  RegistrationRequestSource,
} from "../../../api/psc";
import { useRegistrationContext } from "../context/registrationContext";

export const useRegistrationRequestInputCreator = () => {
  const { state, dispatch } = useRegistrationContext();

  return (dryRun: boolean) => {
    const registrationRequestInput: RegistrationRequestInput = {
      fullName: state.fullName,
      contactNumber: state.contactNumber,
      companyName: state.companyName,
      lineOfWork: state.lineOfWork,
      introductionMethod: state.introductionMethod,
      otpCode: state.otpCode,
      state: state.city,
      source: RegistrationRequestSource.PERSIANSAZE,
      dryRun,
    };

    return registrationRequestInput;
  };
};
